export const AIDocumentManagerKey = {
  PRODUCT: 'product',
  YEAR: 'year',
  FACILITY_TYPE: 'facility',
  DOC_TYPE: 'doc_type',
  BILL_TYPE: 'bill_type',
  DOCUMENT_TYPE: 'doc_type',
  METHOD: 'method'
};

export const AIDocumentManagerLabel = {
  PRODUCT: 'Product',
  YEAR: 'Choose Year',
  FRAMEWORK: 'Framework',
  DOCUMENT_TYPE: 'Document Type',
  FACILITY_TYPE: 'Facility',
  BILL_TYPE: 'Bill Type',
  SUB_BILL_TYPE: 'Bill Sub-type',
  METHOD: 'Method'
};
